var map = {
	"./advantage1.svg": "Y1PB",
	"./advantage2.svg": "xlmt",
	"./advantage3.svg": "o9Sx",
	"./check.svg": "7ZS0",
	"./days.svg": "5MJ5",
	"./dianhua.svg": "P8Iq",
	"./dianhua1.svg": "DlqK",
	"./dizhi1.svg": "6yPw",
	"./email.svg": "+4G4",
	"./gaoxingneng.svg": "uZRs",
	"./index-logo.svg": "eeie",
	"./jengcloud.svg": "nCOT",
	"./light-logo.svg": "R1On",
	"./logo-1.svg": "nVxc",
	"./logo-text.svg": "21N6",
	"./logo.svg": "ZY77",
	"./manual.svg": "OlCb",
	"./news-active.svg": "BDNe",
	"./news.svg": "zgXw",
	"./platform1.svg": "jGc2",
	"./platform2.svg": "7xjU",
	"./platform3.svg": "sQVQ",
	"./platform4.svg": "5KeJ",
	"./public1.svg": "rnBh",
	"./public2.svg": "Pqqt",
	"./public3.svg": "E4VF",
	"./public4.svg": "SLCp",
	"./service.svg": "nCjf",
	"./small-logo.svg": "C74Z",
	"./star.svg": "60zo",
	"./user.svg": "VdD3",
	"./weizhi.svg": "euFX",
	"./youjian.svg": "ZTzG",
	"./yunjisuan.svg": "EVE4",
	"./yunwei.svg": "eH1P"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "90Fk";


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg nonrecursive \.svg$
// module id = 90Fk
// module chunks = 19